"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translateX(-50%) translateY(-50%);\n  border-radius: 50%;\n  background: white;\n  width: calc(", " + 6px);\n  height: calc(", " + 6px);\n  font-size: calc(", " + 4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  background: ", ";\n  border-left: solid ", "\n    ", ";\n  position: relative;\n  border-radius: ", ";\n  *:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Callout = exports.iconMap = void 0;

var icons_1 = require("@ant-design/icons");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var colorMap = {
  info: '@blue',
  warning: '@orange',
  error: '@red',
  success: '@green'
};
exports.iconMap = {
  info: icons_1.InfoCircleOutlined,
  warning: icons_1.ExclamationCircleOutlined,
  error: icons_1.CloseCircleOutlined,
  success: icons_1.CheckCircleOutlined
};

function Callout(_ref) {
  var children = _ref.children,
      type = _ref.type,
      icon = _ref.icon;
  var Icon = exports.iconMap[type];
  return react_1["default"].createElement(Container, {
    type: type
  }, react_1["default"].createElement(TopLeftIcon, {
    type: type
  }, icon ? icon : react_1["default"].createElement(Icon, null)), children);
}

exports.Callout = Callout;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme["".concat(colorMap[props.type], "-light")];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme[colorMap[props.type]];
}, function (props) {
  return props.theme['@border-radius-base'];
});
var TopLeftIcon = styledTypes_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme[colorMap[props.type]];
});